export default __webpack_public_path__ + "static/media/InsideBones_09.53ba07e0.png";